import React, { useState } from "react";
import { Container, Carousel, Row, Col } from "react-bootstrap";

const data = [
  {
    id: 1,
    title: "Assess the Current Setup",
    description:
      "We start by understanding your current infrastructure, deployment flow, dependencies, and the areas creating friction.",
  },
  {
    id: 2,
    title: "Define the Right Environment",
    description:
      "We shape the right cloud and DevOps setup based on system requirements, usage patterns, and operational needs.",
  },
  {
    id: 3,
    title: "Streamline Deployment and Delivery",
    description:
      "We improve how code moves through environments, so, releases are smoother and easier to manage.",
  },
  {
    id: 4,
    title: "Monitor, Refine and Stabilise",
    description:
      "We track system behavior, identify weak points, and make improvements that support more stable day-to-day operations.",
  },
  {
    id: 5,
    title: "Support Ongoing Reliability",
    description:
      "As systems evolve, we continue improving infrastructure, deployment practices, and overall performance.",
  },
];

// Function to group items per slide
const chunkArray = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

export default function ApproachCarousel() {
  const [index, setIndex] = useState(0);

  const itemsPerSlide = 3;
  const slides = chunkArray(data, itemsPerSlide);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <section className="padding-section-large approach-section bg-dark text-white">
      <Container>
        {/* Header */}

        <Row className='mb-4 pt-5 align-items-end mb-5'>
          <Col md={10}>
            <h2 className="heading-style-h2 pb-3">How We Approach<span className="text-gradient-1"> DevOps and Cloud Solutions</span></h2>
            <h5 className='heading-style-h5'>A practical approach to infrastructure, deployment, and system reliability that keeps operations easier to manage over time.</h5>
          </Col>
          <Col md={2}>
            <div className="carousel-controls pb-3">
              <button className="nav-btn" onClick={() =>
                setIndex((index - 1 + slides.length) % slides.length)
              }>
                ‹
              </button>
              <button className="nav-btn" onClick={() => setIndex((index + 1) % slides.length)}>
                ›
              </button>
            </div>
          </Col>
        </Row>
        {/* Carousel */}
        <Carousel
          activeIndex={index}
          onSelect={handleSelect}
          controls={false}
          indicators={false}
          interval={null}
        >
          {slides.map((slide, slideIndex) => (
            <Carousel.Item key={slideIndex}>
              <Row>
                {slide.map((item) => (
                  <Col md={4} key={item.id} className="mb-4">
                    <div className="approach-card d-flex justify-content-between flex-column">
                      <div>
                        <h4 className="heading-style-h4 text-gradient-1">{item.id}</h4>
                        <h4 className="heading-style-h4 pb-5">{item.title}</h4>
                      </div>
                      <p>{item.description}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
        <Row>
          <div className='bg-gradient-2 text-white p-4 mx-auto text-center w-auto mt-5'>
            <p className='mb-0'>The goal is to reduce friction, improve visibility, and make systems easier to manage as they become more demanding.</p>
          </div>
        </Row>
      </Container>
    </section >
  );
}